import React from 'react';
import { Tabs } from 'src/components/Tabs/Tabs';
import { Container, TwoCol, Wrapper } from 'src/components/Layout';
import { PageTitle } from 'src/components/Layout/PageTitle';
import { CmsDeliveryTab } from 'src/components/CmsPage/CmsDeliveryTab';
import { useDeliveryCms } from 'src/components/CmsPage/hooks/useDeliveryCms';
import { SafeHtml } from 'src/components/SafeHtml/SafeHtml';
import { applyCssModuleClasses } from 'src/util/applyCssModuleClasses';

import classes from './CmsDeliveryPage.scss';

type Props = Record<string, unknown>;

export const CmsDeliveryPage: React.FC<Props> = () => {
    const heroImage = require('../../../static/img/cms/delivery-header.png');

    const deliveryCmsData = useDeliveryCms();

    return (
        <div className={classes.container}>
            <section className={classes.hero} style={{ backgroundImage: `url(${heroImage})` }}>
                {' '}
            </section>
            <Wrapper variant="widget-wrapper">
                <Container>
                    <PageTitle title="Delivery" />
                    <TwoCol
                        main={
                            !deliveryCmsData.loading && (
                                <Tabs
                                    tabs={[
                                        {
                                            id: 'uk-ireland',
                                            title: 'UK & Ireland',
                                            icon: 'delivery',
                                            content: <CmsDeliveryTab data={deliveryCmsData.delivery} />,
                                        },
                                        {
                                            id: 'international',
                                            title: 'International',
                                            icon: 'delivery',
                                            content: <CmsDeliveryTab data={deliveryCmsData.international} />,
                                        },
                                        {
                                            id: 'dispatch',
                                            title: '24 Hour Dispatch',
                                            icon: '24hr',
                                            content: <CmsDeliveryTab data={deliveryCmsData.dispatch} />,
                                        },
                                    ]}
                                />
                            )
                        }
                        right={
                            !deliveryCmsData.loading && (
                                <SafeHtml html={applyCssModuleClasses(deliveryCmsData.services || '', classes)} />
                            )
                        }
                    />
                </Container>
            </Wrapper>
        </div>
    );
};
